import { EpRadioGroup } from '../../../../components/EpRadioGroup';
import { EpRadioButton } from '../EpRadioButton';
import { EpErrorMessage } from '../EpErrorMessage';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { useFormContext } from 'react-hook-form';

type EpRadioYesNoProps = {
  legend: string;
  name: string;
  onChange: () => void;
  translations: unknown;
};

export const EpRadioYesNo = ({
  legend,
  name,
  onChange,
  translations,
}: EpRadioYesNoProps) => {
  const { formState: { errors } } = useFormContext();

  return (
    <div onChange={onChange}>
      <EpRadioGroup legend={t(translations, legend) + ' *'}>
        <EpRadioButton
          radioId={`EpRadio__yes`}
          radioValue={'true'}
          radioName={name}
          radioLabel={t(translations, 'Yes')}
          errorMessage={t(translations, '* Required Fied')}
          radioWithError={!!errors[name]}
        />
        <EpRadioButton
          radioId={`EpRadio__no`}
          radioValue={'false'}
          radioName={name}
          radioLabel={t(translations, 'No')}
          errorMessage={t(translations, '* Required Fied')}
          radioWithError={!!errors[name]}
        />
      </EpRadioGroup>
      <EpErrorMessage inputName={`${name}.inputValue`} />
    </div>
  );
};
